import React, { Fragment } from 'react';
import { injectIntl, WrappedComponentProps } from 'react-intl';
import { Circle } from 'react-leaflet';
import { connect } from 'react-redux';
import { DrawerInformationInterface } from '../..';
import { IpCan } from '../../../../handlers/ipcan/IpCan';
import { LPSensorMapInformation_I } from '../../../../handlers/map/MapLPSensor';
import { SensorPlaceType } from '../../../../handlers/sensorPlaceType/SensorPlaceType';
import LPSensorPopup from './LPSensorPopup';

type Props = {
    sensor: LPSensorMapInformation_I;
    circleRadius: number;
    controllers: IpCan[];
    placeTypes: SensorPlaceType[];
    editMode: boolean;
    sensorStateDisplayed: boolean;
    auth?: any;
    service: any;
    blinkState: number;
    drawerInformation: DrawerInformationInterface;
    openDrawer: Function;
    closeDrawer: Function;
    isEditingSensors: boolean;
} & WrappedComponentProps;

type State = {
    occupiedPercent: number;
    forcedPercent: number;
    hoverPopup: boolean;
    isAdmin: boolean;
    controller: IpCan | undefined;
};

class LPSensorPlaceIcon extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            occupiedPercent: 0.65,
            forcedPercent: 0.3,
            hoverPopup: true,
            isAdmin: false,
            controller: undefined,
        };
    }

    componentDidMount() {
        const isAdmin =
            this.props.auth?.user.roles.find(data => {
                return data.name === 'Admin';
            }) || false;

        const controller = this.props.controllers.find(controller => controller.id === this.props.sensor.ipCanId);

        this.setState({
            isAdmin,
            controller,
        });
    }

    onMouseOver = event => {
        this.setState({
            hoverPopup: true,
        });

        event.target.openPopup();
    };

    onMouseOut = event => {
        if (this.state.hoverPopup) {
            event.target.closePopup();
        }
    };

    openPopup = event => {
        this.setState({
            hoverPopup: false,
        });
        event.target.openPopup();
    };

    handleClosePopup = () => {
        this.setState({
            hoverPopup: true
        })
    }

    generateForceColor = () => {
        const { red, green, blue } = this.props.sensor.forceType.color;
        // const blinkState = this.props.blinkState % this.props.sensor.scenes[0].length;

        switch (this.props.sensor.forceType.forceType) {
            case 1: {
                try {
                    return this.props.sensor.scenes[0].getStep(this.props.blinkState).color;
                } catch (e) {
                    return 'transparent';
                }
            }
            case 2:
                try {
                    return this.props.sensor.scenes[1].getStep(this.props.blinkState).color;
                } catch (e) {
                    return 'transparent';
                }
            case 3:
                try {
                    return this.props.sensor.scenes[2].getStep(this.props.blinkState).color;
                } catch (e) {
                    return 'transparent';
                }
            case 4:
                try {
                    return this.props.sensor.scenes[3].getStep(this.props.blinkState).color;
                } catch (e) {
                    return 'transparent';
                }
            case 10:
                return `rgb(${red}, ${green}, ${blue})`;
            default:
                return 'transparent';
        }
    };

    generateColor = () => {
        try {
            return this.props.sensor.scenes[0].getStep(this.props.blinkState).color;
        } catch (e) {
            return 'transparent';
        }
    };

    generateCircleColor = () => {
        const { isForce, detectionState, online } = this.props.sensor;
        const { eventForceType, eventForceColor } = this.props.sensor.lpSensor;

        if (!online) {
            try {
                return this.props.sensor.scenes[0].getStep(0).color;
            } catch {
                return 'transparent';
            }
        }

        try {
            if (this.props.sensorStateDisplayed || !this.state.isAdmin) {
                if (eventForceType === 'lp-sensor_force_color') {
                    return `rgb(${eventForceColor.red}, ${eventForceColor.green}, ${eventForceColor.blue})`;
                } else if (isForce) {
                    return this.generateForceColor();
                } else {
                    return this.props.sensor.scenes[detectionState - 1].getStep(this.props.blinkState).color;
                }
            } else {
                return this.props.sensor.scenes[0].getStep(this.props.blinkState).color;
            }
        } catch {
            return 'transparent';
        }
    };

    render() {
        const displayEventForceType =
            this.props.sensor.lpSensor.eventForceType === 'lp-sensor_force_color' &&
            this.props.sensorStateDisplayed &&
            !this.props.isEditingSensors;

        const displayForceType =
            !displayEventForceType &&
            this.props.sensor.isForce &&
            this.props.sensorStateDisplayed &&
            !this.props.isEditingSensors;

        return (
            <Fragment>
                <Circle
                    radius={this.props.circleRadius}
                    color={this.generateCircleColor()}
                    fillColor={this.generateColor()}
                    opacity={1}
                    weight={5}
                    center={this.props.sensor.geoJSON}
                    fillOpacity={!this.props.sensor.online && this.state.isAdmin ? 0.3 : 1}
                    stroke={true}
                    name={`${this.props.sensor.mapSensorId}-lp`}
                    onmouseover={this.onMouseOver}
                    onmouseout={this.onMouseOut}
                    onclick={this.openPopup}>
                    <LPSensorPopup
                        sensor={this.props.sensor}
                        editMode={this.props.editMode}
                        controller={this.state.controller}
                        placeTypes={this.props.placeTypes}
                        overPopup={this.state.hoverPopup}
                        closePopup={this.handleClosePopup}
                        controllers={this.props.controllers}
                        service={this.props.service}
                        drawerInformation={this.props.drawerInformation}
                        openDrawer={this.props.openDrawer}
                        closeDrawer={this.props.closeDrawer}
                    />
                </Circle>
                {displayForceType && (
                    <Circle
                        radius={3}
                        color="#000"
                        fillColor="#000"
                        fillOpacity={1}
                        opacity={1}
                        stroke={false}
                        center={this.props.sensor.geoJSON}
                        onmouseover={this.onMouseOver}
                        onmouseout={this.onMouseOut}
                        onclick={this.openPopup}>
                        <LPSensorPopup
                            sensor={this.props.sensor}
                            editMode={this.props.editMode}
                            controller={this.state.controller}
                            placeTypes={this.props.placeTypes}
                            overPopup={this.state.hoverPopup}
                            closePopup={this.handleClosePopup}
                            controllers={this.props.controllers}
                            service={this.props.service}
                            drawerInformation={this.props.drawerInformation}
                            openDrawer={this.props.openDrawer}
                            closeDrawer={this.props.closeDrawer}
                        />
                    </Circle>
                )}

                {displayEventForceType && (
                    <Circle
                        radius={3}
                        color="#EE6352"
                        fillColor="#EE6352"
                        fillOpacity={1}
                        opacity={1}
                        stroke={false}
                        center={this.props.sensor.geoJSON}
                        onmouseover={this.onMouseOver}
                        onmouseout={this.onMouseOut}
                        onclick={this.openPopup}>
                        <LPSensorPopup
                            sensor={this.props.sensor}
                            closePopup={this.handleClosePopup}
                            editMode={this.props.editMode}
                            controller={this.state.controller}
                            placeTypes={this.props.placeTypes}
                            overPopup={this.state.hoverPopup}
                            controllers={this.props.controllers}
                            service={this.props.service}
                            drawerInformation={this.props.drawerInformation}
                            openDrawer={this.props.openDrawer}
                            closeDrawer={this.props.closeDrawer}
                        />
                    </Circle>
                )}
            </Fragment>
        );
    }
}

function mapStateToProps(state) {
    const { auth } = state;

    return { auth };
}

export default connect(mapStateToProps)(injectIntl(LPSensorPlaceIcon));
